import { useContext } from 'react';
import FloatingUiTrialContext from './FloatingUiTrialContext.js';

function useFloatingUiTrialContext() {
    return useContext(FloatingUiTrialContext);
}

export { useFloatingUiTrialContext as default };
